import '@mdi/font/css/materialdesignicons.css';

import { createVuetify } from 'vuetify';

import Ripple from 'vuetify/directives/ripple';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

 // Подключаем UI компоненты по отдельности'
import { VSelect } from 'vuetify/components';
import { VChip } from 'vuetify/components';
import { VList } from 'vuetify/components';
import { VListItem } from 'vuetify/components';
import { VAutocomplete } from 'vuetify/components';
import { VProgressCircular } from 'vuetify/components';

const vuetify = createVuetify({
    colors: {
        primary: '#0678F4',
        'on-primary': '#FFFFFF',
    },

    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },

    components: { VSelect, VAutocomplete, VChip, VList, VListItem, VProgressCircular },

    directives: {
        Ripple,
    },
})

export default vuetify;
